import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import { Loading } from "../../App";
import Ajax, { domain } from "../../ajax/Ajax";

class AvailableShops extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shops: null,
    };

    this.fetchAvailableShops = this.fetchAvailableShops.bind(this);

    this.owlcarousel = React.createRef();
  }

  async fetchAvailableShops() {
    let fetchResults = await Ajax.fetchData(
      domain + "/en/api/shop/v1/available-shops/"
    );
    console.log(fetchResults);

    if (fetchResults) {
      if (fetchResults.status === 200) {
        this.setState({
          shops: fetchResults.data,
        });
      }
    }
  }

  componentDidMount() {
    this.fetchAvailableShops();
  }

  render() {
    return (
      <div className="container mt-4">
        {this.state.shops ? (
          <div className="columns is-mobile">
            <div className="column is-1 is-hidden-mobile">
              <div>
                <button
                  title="Backward"
                  onClick={() => {
                    this.owlcarousel.current.prev();
                  }}
                  className="button is-light is-round"
                >
                  <span className="fas fa-angle-left"></span>
                </button>
              </div>
            </div>

            <div className="column is-10 d-flex justify-content-center">
              <OwlCarousel
                ref={this.owlcarousel}
                className="owl-theme"
                items={4}
                loop
                responsive={{
                  0: {
                    items: 1,
                  },
                  600: {
                    items: 2,
                  },
                  1000: {
                    items: 4,
                  },
                }}
                dots={false}
                margin={30}
              >
                {this.state.shops.map((shop) => (
                  <div key={"available-shops-" + shop.id} className="item">
                    <Link
                      to={{
                        pathname:
                          "/shop-at/" +
                          shop.name.replace(/\s+/g, "-") +
                          "/" +
                          shop.id +
                          "/",
                        state: {
                          shop: shop,
                        },
                      }}
                    >
                      <button className="button">
                        <span>{shop.name}</span>
                      </button>
                    </Link>
                  </div>
                ))}
              </OwlCarousel>
            </div>

            <div className="column is-1">
              <div>
                <button
                  title="Forward"
                  onClick={() => {
                    this.owlcarousel.current.next();
                  }}
                  className="button is-light is-round"
                >
                  <span className="fas fa-angle-right"></span>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Loading />
          </div>
        )}
      </div>
    );
  }
}

export default AvailableShops;
